import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { showErrorNotification } from '../actions/App';
import * as pupilsActions from '../actions/Pupils';
import { searchPupils, getPupilsDeliveryLocation } from '../api/Pupils';
import { SEARCH_PUPILS, GET_PUPILS_DELIVERY_LOCATION } from '../constants/ActionTypes';

function* searchPupilsByFilter({ payload }) {
  try {
    const response = yield call(searchPupils, payload.filter, payload.selectedPupilsIds, payload.pageSize);
    yield put(pupilsActions.searchPupilsSuccess(response.data.entities, response.data.pageCount));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
    yield put(pupilsActions.searchPupilsFailure());
  }
}

function* getStudentsDeliveryLocation({ payload: { studentId } }) {
  try {
    const { data } = yield call(getPupilsDeliveryLocation, studentId);
    yield put(pupilsActions.getPupilsDeliveryLocationSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

export function* searchPupilsByFilterSaga() {
  yield takeLatest(SEARCH_PUPILS, searchPupilsByFilter);
}

export function* getStudentsDeliveryLocationSaga() {
  yield takeLatest(GET_PUPILS_DELIVERY_LOCATION, getStudentsDeliveryLocation);
}

export default function* rootSaga() {
  yield all([fork(searchPupilsByFilterSaga), fork(getStudentsDeliveryLocationSaga)]);
}
